/**
 * Retorna a configuração de coluna de status para tabelas de receita,
 * com badge colorido conforme o status da receita.
 */

import { STATUS_COLOR_PALETTE } from './statusColorPalette';

const statusColors = {
    received: STATUS_COLOR_PALETTE.green,
    pending: STATUS_COLOR_PALETTE.yellow,
    overdue: STATUS_COLOR_PALETTE.red,
    partially_received: STATUS_COLOR_PALETTE.orange,
    cancelled: STATUS_COLOR_PALETTE.grey,
};

export const revenueStatusCell = (row) => {
    const color = statusColors[row.status] || '#a0aec0';
    return (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{
                display: 'inline-block',
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: color,
                flexShrink: 0,
            }} />
            {row.formattedStatus}
        </span>
    );
};
